<template>
  <div class="agreement-container">
    <h1>用户服务协议</h1>

    <div class="content">
      <p>
        欢迎使用“猫小悟”（以下简称“本应用”）。在使用本应用前，请您仔细阅读本协议。
        您的注册、登录及使用行为即视为您已阅读并同意本协议全部内容。
        <br />
        最近更新日期：2026年8月8日
      </p>

      <h3>一、协议范围</h3>
      <p>
        本协议是您与本应用开发者之间就您使用本应用所订立的协议。
      </p>

      <h3>二、服务内容</h3>
      <p>
        本应用为用户提供书单浏览、发布书单、评论互动等功能服务。
      </p>

      <h3>三、账号注册与使用</h3>
      <p>
        1. 您可以通过手机号注册账号，并应保证所提供信息真实有效。<br />
        2. 您应妥善保管账号信息，并对账号下的所有行为负责。<br />
        3. 如发现账号被盗用，请及时与我们联系。
      </p>

      <h3>四、用户内容规范</h3>
      <p>
        您在使用本应用时发布的内容（包括书单、评论等），应遵守相关法律法规，不得包含以下内容：
      </p>
      <p>
        - 违法违规信息<br />
        - 侵犯他人权益的内容<br />
        - 虚假或误导性信息<br />
        - 其他不适当内容
      </p>
      <p>
        我们有权对违规内容进行删除、屏蔽或采取限制措施。
      </p>

      <h3>五、用户行为规范</h3>
      <p>
        您在使用本应用过程中，不得从事以下行为：
      </p>
      <p>
        - 干扰应用正常运行<br />
        - 利用漏洞进行不正当行为<br />
        - 进行任何危害系统安全的行为
      </p>

      <h3>六、服务变更与中断</h3>
      <p>
        我们可能根据实际情况对服务内容进行调整、升级或中断。
      </p>

      <h3>七、免责声明</h3>
      <p>
        本应用将尽力保障服务稳定运行，但不对因不可抗力、网络问题等导致的服务中断承担责任。
      </p>

      <h3>八、知识产权</h3>
      <p>
        本应用的相关内容（包括但不限于界面设计、功能结构等）受法律保护，未经许可不得复制或使用。
      </p>

      <!-- 新增：第三方SDK接入说明章节，满足京东联盟及Bugly合规要求 -->
      <h3>九、第三方SDK接入说明</h3>
      <p>
        为向您提供更全面的服务，本应用接入了第三方服务商的SDK。在使用本应用前，请您仔细阅读并充分理解以下关于各SDK的信息。当您同意本协议时，即视为您已同意相关SDK按照下文说明收集、使用您的个人信息。
      </p>

      <p><strong>1. 京东联盟广告SDK</strong></p>
      <p>
        <strong>运营方：</strong> 京东集团<br />
        <strong>使用目的：</strong> 实现广告投放、唤起京东App、提供商品/活动推广及闭环交易等服务。<br />
        <strong>收集信息及权限：</strong>
      </p>
      <p>
        <strong>● 收集的个人信息：</strong><br />
        - 【必选信息】为提供基本广告服务，可能包括：设备信息（如设备型号、操作系统版本、IP地址）、网络信息等。<br />
        - 【可选信息】为提供联合登录、闭环交易等扩展功能，可能包括：手机号码、网络类型、网络地址、运营商类型等。
      </p>
      <p>
        <strong>● 申请的权限：</strong><br />
        - 【Android】可能申请网络访问、网络状态、Wi-Fi状态等权限。<br />
        - 【iOS】无特殊权限申请。<br />
        - 【Harmony OS】可能申请网络访问、网络状态等权限。
      </p>
      <p>
        <strong>● 调用的第三方服务：</strong><br />
        为优化用户体验，SDK可能集成以下第三方一键登录服务（不涉及数据共享，仅用于接口调用）：<br />
        - 联通一键登录（收集本机号码、网络类型、IP地址等）<br />
        - 移动一键登录（收集本机号码、IP地址、SIM卡状态等）<br />
        - 电信一键登录（收集本机号码、网络状态、IP地址等）<br />
        详细隐私政策请参考各运营商官方说明。
      </p>
      <p>
        <strong>SDK隐私政策：</strong> <a href="https://union.jd.com/searchResultDetail?articleId=177725" target="_blank">https://union.jd.com/searchResultDetail?articleId=177725</a>
      </p>
      <p>
        <strong>合规说明：</strong> 本应用会在您同意本协议后，再初始化京东联盟广告SDK。您可以通过设备的系统设置管理相关权限，撤回授权可能导致部分功能无法使用，但不会影响其他功能。
      </p>

      <p><strong>2. 腾讯Bugly SDK</strong></p>
      <p>
        <strong>运营方：</strong> 深圳市腾讯计算机系统有限公司<br />
        <strong>使用目的：</strong> 应用崩溃监控、错误上报及性能分析，帮助开发者快速发现并修复线上问题，保障应用稳定运行。<br />
        <strong>收集的个人信息：</strong> 设备标识信息（如Android ID、ICCID）、设备型号、操作系统版本、运行中的进程信息。<br />
        <strong>申请的权限：</strong><br />
        - 【Android】可能申请网络访问、读取手机状态等权限。<br />
        - 【iOS】无特殊权限申请。
      </p>
      <p>
        <strong>SDK隐私政策：</strong> <a href="https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56" target="_blank">https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56</a>
      </p>
      <p>
        <strong>合规说明：</strong> 本应用会在您同意本协议后，再初始化腾讯Bugly SDK。该SDK仅用于技术诊断目的，不会将收集的信息用于广告或营销。</p>

      <h3>十、协议修改</h3>
      <p>
        我们有权根据需要修改本协议，修改后的协议将在应用内公布。
      </p>

      <h3>十一、联系我们</h3>
      <p>
        如您对本协议有任何疑问，请通过以下方式联系我们：
      </p>
      <p>
        邮箱：1353966998@qq.com
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserAgreement'
}
</script>

<style scoped>
/* 样式保持不变 */
.agreement-container {
  padding: 20px;
  background: #fff;
}

h1 {
  text-align: center;
  margin-bottom: 20px;
}

.content {
  text-align: left;
  line-height: 1.8;
  font-size: 14px;
  color: #333;
}

h3 {
  margin-top: 20px;
  font-size: 16px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/module/privacy/UserService.vue